export default {
    computed: {
        screenWidth() {
            return this.$store.state.global.screenWidth
        }
    }
}